import { r as i, h as t, H as r } from "./main-bb89b2f2.js";
import "vue";
const a = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.static{position:static}.py-4{padding-bottom:var(--spacing-4);padding-top:var(--spacing-4)}.px-4{padding-left:var(--spacing-4);padding-right:var(--spacing-4)}.pt-2{padding-top:var(--spacing-2)}", o = a, n = class {
  constructor(e) {
    i(this, e);
  }
  render() {
    return t(r, { key: "1c118d3b34319d569495c67e33786a572e92aa8e" }, t("div", { key: "7d63b0fb8a53c5b872c4bc759510ed57f3d1d77a", class: {
      "py-4 px-4 pt-2": !0
    } }, t("slot", { key: "b326eee5399ce916bf711256fde852f22e0ece50" })));
  }
};
n.style = o;
export {
  n as patternlib_dashboard_card_footer
};
